import { render, staticRenderFns } from "./kLine.vue?vue&type=template&id=c1fa229a&scoped=true"
import script from "./kLine.vue?vue&type=script&lang=js"
export * from "./kLine.vue?vue&type=script&lang=js"
import style0 from "./kLine.vue?vue&type=style&index=0&id=c1fa229a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1fa229a",
  null
  
)

export default component.exports